import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { TableList, Loader, Button } from '@ederzadravec/jade-ui';
import { FaCheckDouble, FaCheck } from 'react-icons/fa';

import { FormHtml, Text } from 'components';
import { useService } from 'service';

const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: auto;
  margin-bottom: 24px;
`;

const IconVisible = styled(FaCheckDouble)`
  margin: 0 0 0 8px;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.primary.main};
`;

const IconNotVisible = styled(FaCheck)`
  margin: 0 0 0 8px;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.black.main};
`;

const Updated = ({ data, refresh }) => {
  const RouteParams = useParams();
  const [, { loading }, updateVisibleHtml] = useService(
    'patch',
    `/room/${RouteParams.room}/html/${data._id}/active`,
    {},
    false
  );
  const handleOnIsVisible = async (id, visible) => {
    await updateVisibleHtml({
      _id: id,
      isVisible: !visible,
    });

    refresh();
  };

  if (loading) return null;

  return (
    <Text
      type="link"
      color="black"
      center
      onClick={() => handleOnIsVisible(data._id, data.isVisible)}>
      {data.isVisible === false ? <IconNotVisible /> : <IconVisible />}
    </Text>
  );
};

export const Html = () => {
  const [showForm, setShowForm] = React.useState(false);

  const RouteParams = useParams();
  const [htmlsData, { loading }, refreshHtmls] = useService(
    'get',
    `/room/${RouteParams.room}/html`
  );

  const handleOnCloseForm = refresh => {
    setShowForm(false);

    if (refresh) refreshHtmls();
  };

  const listConfig = [
    {
      name: 'Name',
      size: { md: 10 },
      dataPath: 'name.pt',
    },
    {
      name: 'Ação',
      size: { md: 2 },
      dataPath: data => <Updated data={data} refresh={refreshHtmls} />,
    },
  ];

  const polls = htmlsData?.success?.htmls?.data || [];

  return (
    <>
      <Loader show={loading}>
        <TableList config={listConfig} data={polls} />
      </Loader>

      <Footer>
        <Button onClick={() => setShowForm(true)}>Novo</Button>
      </Footer>

      {showForm && <FormHtml onClose={handleOnCloseForm} id_room={RouteParams.room} />}
    </>
  );
};
